import React, { Component } from 'react';
import { ColorPicker } from 'material-ui-color';
import Button from '@mui/material/Button';
import MainStore from '../../../MainStore'
import './users.css'

export default class ProjectTypeColorBlock extends Component {

    constructor(props) {
        super(props);

        this.state = {
            types: []
        };

        this.loadTypes = this.loadTypes.bind(this);
        this.handleColorChange = this.handleColorChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    componentDidMount() {
        this.loadTypes();
    }

    loadTypes() {
        var scope = this;
        fetch('api/Project/Types', {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ types: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleColorChange(id, color) {
        if (color) {
            var types = this.state.types.slice(0);
            types[types.findIndex(t => t.id === id)].color = color;
            this.setState({ types: types });
        }
    }

    handleSave() {
        var scope = this;
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Project/SaveTypes', {
            method: 'POST',
            body: JSON.stringify(this.state.types),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    alert("Успех");
                    MainStore.setMaskUnvisible();
                }).catch((err) => console.log(err));
            }
        });
    }

    render() {

        var types = this.state.types && this.state.types.map(p => <div key={p.id}>{p.name} <ColorPicker
            name='color'
            defaultValue={p.color}
            // value={this.state.color} - for controlled component
            onChange={color => this.handleColorChange(p.id, color)}
        /><div className="color-example-square" style={{ background: p.color }}></div></div>);
        return (
            <div>
                Цвета типов проектов
                {types}
                <Button variant="contained" component="span" onClick={this.handleSave}>
                    Сохранить
                </Button>
            </div>
        );
    }
}
